<template>
  <div>
    <screening-progress-legend-item
      v-for="legendItem in legendItems"
      :key="legendItem.label"
      :count="legendItem.count"
      :label="legendItem.label"
      :color="legendItem.color"
      :show-count="showCounts"
      class="py-1"
    />
  </div>
</template>

<script>
import ScreeningProgressLegendItem from '@/components/ReviewSummary/ScreeningProgressLegendItem';

export default {
  name: 'ScreeningProgressLegend',
  components: { ScreeningProgressLegendItem },
  props: {
    legendItems: {
      type: Array,
      required: true,
    },
    showCounts: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>
